import { get } from 'lodash';

export default {
  features: state => state.features,
  isFeatureEnabled: state => featureName => get(state.features, featureName, false),
};
